export default __webpack_public_path__ + "static/media/machineBackground.0effd3d9.mp3";